import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c52728ec")

_pushScopeId("data-v-c52728ec")
const _hoisted_1 = { class: "ExpressSettedAdditionalData" }
const _hoisted_2 = { class: "ExpressSettedAdditionalData__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", { class: "header__title" }, "Дополнительная информация", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Наложенный платёж: ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Не указан ")
const _hoisted_7 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit = _resolveComponent("icon-edit")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_icon_edit, {
            key: 0,
            class: "header__edit",
            onClick: _ctx.emitReset
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_4,
    _createVNode("p", null, [
      _hoisted_5,
      (_ctx.amountToAcceptPayment)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.amountToAcceptPayment) + " тенге ", 1)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _hoisted_6
          ], 64))
    ]),
    _createVNode("p", null, "Верификация SPARK: " + _toDisplayString(_ctx.verificationType === _ctx.SPARK_VERIFICATION_ID ? 'Да' : 'Нет'), 1),
    _createVNode("p", null, "Верификация Kaspi: " + _toDisplayString(_ctx.verificationType === _ctx.KASPI_VERIFICATION_ID ? 'Да' : 'Нет'), 1),
    (_ctx.verificationType === _ctx.KASPI_VERIFICATION_ID)
      ? (_openBlock(), _createBlock("p", _hoisted_7, " Номер заказа Kaspi: " + _toDisplayString(_ctx.verificationInvoiceNumber || '-'), 1))
      : _createCommentVNode("", true),
    _createVNode("p", null, "Номер накладной заказчика: " + _toDisplayString(_ctx.verificationInvoiceNumber || '-'), 1),
    _createVNode("p", null, "Комментарий к заказу: " + _toDisplayString(_ctx.extraInfo || '-'), 1)
  ]))
})